module.exports = __webpack_public_path__ + "img/3min_scan.1277d506.png";